import React from 'react';
import { useTranslation } from 'react-i18next';

import Icon from '~/components/icon';

import styles from '../../MobileBottomNav.module.css';

interface AllSportsButtonProps {
  allSportsOpen: boolean;
  setAllSportsOpen: (open: boolean) => void;
}

export const AllSportsButton = ({
  allSportsOpen,
  setAllSportsOpen
}: AllSportsButtonProps) => {
  const { t } = useTranslation(['label']);

  return (
    <li
      className={`${styles.menuItem} ${styles.allSportsButton} ${allSportsOpen ? styles.active : ''}`}
      id="all-sports-button"
      key={'allSports'}
      onClick={() => setAllSportsOpen(!allSportsOpen)}>

			<span className={styles.iconContainer}>
				<Icon height={20} icon="AmericanFootball" width={20} />
			</span>
			{t('CX_ODDS')}
		</li>);

};